module.exports = __webpack_public_path__ + "img/Dantam Hair 47.bc1cd29e.jpg";